import { DataLayerEvent } from './datalayer'
import { DetailedPageInfo } from './clientState'
import {
  TrackingProduct,
  TrackingBasketItem,
  TrackingWishlistItem,
  TrackingPrice,
} from '../../../types'
import { stringifyEventData } from './stringifyEventData'
import { calcCentsToEuro } from './prices'

export type CommonEventData = Pick<DataLayerEvent, 'action' | 'label' | 'value'>

export function commonEventDataHandler({
  currentPage,
  product,
}: {
  currentPage: DetailedPageInfo
  product: TrackingProduct
}): CommonEventData {
  return {
    action: stringifyEventData([currentPage.page.type, currentPage.page.id]),
    label: `${product.id}`,
    value: calcCentsToEuro(product.minPrice.withoutTax).toFixed(2),
  }
}

export function calculateTotalPrice(
  items: Array<TrackingBasketItem | TrackingWishlistItem>,
): TrackingPrice {
  let currency = ''
  let campaignReductionWithTax = 0
  let saleReductionWithTax = 0
  let withTax = 0
  let withoutTax = 0

  for (const item of items) {
    currency = item.product.minPrice.currency

    const itemPrice = item.variant ? item.variant.price : item.product.minPrice

    campaignReductionWithTax += itemPrice.campaignReductionWithTax
    saleReductionWithTax += itemPrice.saleReductionWithTax
    withTax += itemPrice.withTax
    withoutTax += itemPrice.withoutTax
  }

  return {
    currency,
    campaignReductionWithTax,
    saleReductionWithTax,
    withTax,
    withoutTax,
  }
}
